import CreditCardIcon from '@mui/icons-material/CreditCard';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { Box } from '@mui/material';
import { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { YouCanComeBackNote } from '../../../../general/components/footers/you-can-come-back-note';
import { WizardPage } from '../../../../general/components/wizard-page';
import { ProgressButton } from '../../../../general/inputs/progress-button';
import { RootState } from '../../../../store';
import { PersonaPrerequisite } from '../../components/persona-prerequisite';
import { loadPersona } from '../../reducers/persona';

const selector = ({ persona, nextStep: { loading: appLoading } }: RootState) => ({
  ...persona,
  loading: persona.loading || appLoading,
});

const PersonaPage: FC = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector(selector);

  const handleNext = useCallback(() => {
    dispatch(loadPersona());
  }, [dispatch]);

  return (
    <WizardPage
      title="We need to verify your identity!"
      subtext={
        <>
          We need to take an additional step to ensure
          <br /> the security of your account.
        </>
      }
      error={error}
      footer={<YouCanComeBackNote />}
    >
      <Box sx={{ display: 'grid', gap: 2 }}>
        <PersonaPrerequisite
          title="Use your ID"
          subtext="Please have your government issued ID ready."
          icon={<CreditCardIcon color="primary" />}
        />
        <PersonaPrerequisite
          title="Webcam"
          subtext="You will be able to complete the next steps with your webcam or with your mobile phone."
          icon={<PhotoCameraIcon color="primary" />}
        />
      </Box>

      <ProgressButton
        type="submit"
        color="primary"
        fullWidth
        progress={loading}
        size="large"
        sx={{ mt: 4 }}
        variant="contained"
        onClick={handleNext}
      >
        Begin Verification
      </ProgressButton>
    </WizardPage>
  );
};

export { PersonaPage };
